export default "__VITE_ASSET__K1VFr3g$__"